var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wide-grid"},_vm._l((_vm.rooms),function(room){return _c('RoomSelectWithTimetable',{key:room.id,staticClass:"room-box",style:(_vm.style),attrs:{"date":_vm.date,"roomId":room.id}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a08a6b7a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RoomSelectWideGrid.vue
// module id = null
// module chunks = 